import { render, staticRenderFns } from "./LanguagePickerButton.vue?vue&type=template&id=ece27d6a&"
import script from "./LanguagePickerButton.vue?vue&type=script&lang=js&"
export * from "./LanguagePickerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports